import { Action, combineReducers } from '@reduxjs/toolkit';
import { RESET_APP } from '../utils/authActions';
import ApplicationSlice from './ApplicationSlice';
import AuthSlice from './AuthSlice';
import DropboxSlice from './DropboxSlice';
import LoanSlice from './LoanSlice';
import PaymentSlice from './PaymentSlice';
import ToastNotificationSlice from './ToastNotificationSlice';
import ThemeSlice from './ThemeSlice';
import LeoSlice from './LeoSlice';

const appReducer = combineReducers({
  auth: AuthSlice,
  loan: LoanSlice,
  application: ApplicationSlice,
  dropbox: DropboxSlice,
  payment: PaymentSlice,
  toastNotification: ToastNotificationSlice,
  theme: ThemeSlice,
  leo: LeoSlice,
});

const rootReducer = (state: any, action: Action) => {
  if (action.type === RESET_APP) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
